export enum PostMessageType {
  LiveStreamEnded = 'liveStreamEnded',
  Unauthorized = 'unauthorized',
  SessionExpired = 'sessionExpired',
  LiveChatContentToggle = 'liveChatContentToggle',
  LiveChatUnreadStatus = 'liveChatUnreadStatus'
}